export class GeolocationError extends Error {}
